import { doc, DocumentData, updateDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ICompany } from '@leedpulse-monorepo/interfaces';

async function updateCompany(
  id: string,
  companyDoc: ICompany,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdateCompanyFailure('Unauthorized', 'unauthorized');
  }

  if (
    id === '' ||
    companyDoc.name === '' ||
    companyDoc.id_subscriptions === null
  ) {
    throw new UpdateCompanyFailure('Les informations renseignées sont incomplètes');
  }

  try {
    // `billing` is a Stripe mirror, never edited here: sending it back overwrote the webhooks
    const { billing: _billing, ...patch } = companyDoc;

    await updateDoc(
      doc(firestore, FirestoreCollections.companies, id),
      patch as DocumentData
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new UpdateCompanyFailure();
  }
}

export class UpdateCompanyFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateCompany;
